import { render, staticRenderFns } from "./verifyLogin.vue?vue&type=template&id=36c58f5c"
import script from "./verifyLogin.vue?vue&type=script&lang=js"
export * from "./verifyLogin.vue?vue&type=script&lang=js"
import style0 from "./verifyLogin.vue?vue&type=style&index=0&id=36c58f5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports